import { Injectable } from '@angular/core';
import {TransmissionService} from "./transmission.service";
import {HttpClient} from "@angular/common/http";
import {HttpErrorHandlerService} from "../http-error-handler.service";
import {JWTService} from "../../authentication/jwt.service";
import {PasteboxService} from "../../services/pastebox.service";
import {IProductNotifyStock} from "../../product-details/interface/product-notify-stock";
import {RaintreeResponse} from "../interface/raintree-response";
import {RequestMapperService} from "../../request-mapper.service";

@Injectable({
	providedIn: 'root'
})
export class OutOfStockTransmissionService extends TransmissionService {

	constructor(
		_http: HttpClient,
		_httpErrorHandler: HttpErrorHandlerService,
		_jwt: JWTService,
		_pastebox: PasteboxService
	) {
		super(
			_http,
			_httpErrorHandler,
			_jwt,
			_pastebox
		);
	}

	public addOutOfStockNotification(
		payload: IProductNotifyStock,
		onPreExecute: () => void,
		onPostExecute: (response: RaintreeResponse) => void,
		onSuccess: (response: RaintreeResponse) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	): void {
		this.executePostPayload(
			RequestMapperService.ADD_OUT_OF_STOCK,
			payload,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			true
		);
	}

	public updateOutOfStockNotificationQuantity(
		payload: {
			requestId: number,
			quantity: number,
		},
		onPreExecute: () => void,
		onPostExecute: (response: RaintreeResponse) => void,
		onSuccess: (response: RaintreeResponse) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	): void {
		this.executePatchPayload(
			RequestMapperService.UPDATE_OUT_OF_STOCK_QUANTITY,
			payload,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			true
		);
	}


}
